// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import 'babel-polyfill'
import router from './router'
import store from './store'
import tool from './utils/tool'
import Bus from './utils/bus'
import Fun from './servers/postageMgr'
import Api from './api/index'
import 'mint-ui/lib/style.css'
import '../static/css/my-mint.scss'
import Buriedpoint from './servers/buriedpoint'
import Vconsole from 'vconsole'
import Es6Promise from 'es6-promise'

if (Api.Vconsole) {
	const vConsole = new Vconsole()
	Vue.use(vConsole) // 页面调试
}
Vue.prototype.$tool = tool // 全局方法
Vue.prototype.$bus = Bus // 事件监听
Vue.prototype.$fun = Fun // 获取数据方法
Vue.prototype.$api = Api // Api
Vue.config.productionTip = false
Vue.prototype.$Buriedpoint = Buriedpoint // 埋点
Es6Promise.polyfill()

/* eslint-disable */
Number.prototype.toFixed = function(d) {
	var s = this + "";
	if(!d) d = 0;
	if(s.indexOf(".") == -1) s += ".";
	s += new Array(d + 1).join("0");
	if(new RegExp("^(-|\\+)?(\\d+(\\.\\d{0," + (d + 1) + "})?)\\d*$").test(s)) {
		var s = "0" + RegExp.$2,
			pm = RegExp.$1,
			a = RegExp.$3.length,
			b = true;
		if(a == d + 2) {
			a = s.match(/\d/g);
			if(parseInt(a[a.length - 1]) > 4) {
				for(var i = a.length - 2; i >= 0; i--) {
					a[i] = parseInt(a[i]) + 1;
					if(a[i] == 10) {
						a[i] = 0;
						b = i != 1;
					} else break;
				}
			}
			s = a.join("").replace(new RegExp("(\\d+)(\\d{" + d + "})\\d$"), "$1.$2");
		}
		if(b) s = s.substr(1);
		return(pm + s).replace(/\.$/, "");
	}
	return this + "";
};
/* eslint-enable */

/* eslint-disable no-new */
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js